/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SwitchToLinkedCompanyResponse
 */
export interface SwitchToLinkedCompanyResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SwitchToLinkedCompanyResponse
     */
    success: boolean;
    /**
     * A message safe to show the customer explaining why the switch failed. Never carries internal exception detail.
     * @type {string}
     * @memberof SwitchToLinkedCompanyResponse
     */
    errorMessage?: string;
    /**
     * Indicates if the frontend should refresh the auth token
     * @type {boolean}
     * @memberof SwitchToLinkedCompanyResponse
     */
    requiresTokenRefresh?: boolean;
}

/**
 * Check if a given object implements the SwitchToLinkedCompanyResponse interface.
 */
export function instanceOfSwitchToLinkedCompanyResponse(value: object): value is SwitchToLinkedCompanyResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    return true;
}

export function SwitchToLinkedCompanyResponseFromJSON(json: any): SwitchToLinkedCompanyResponse {
    return SwitchToLinkedCompanyResponseFromJSONTyped(json, false);
}

export function SwitchToLinkedCompanyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SwitchToLinkedCompanyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'requiresTokenRefresh': json['requiresTokenRefresh'] == null ? undefined : json['requiresTokenRefresh'],
    };
}

  export function SwitchToLinkedCompanyResponseToJSON(json: any): SwitchToLinkedCompanyResponse {
      return SwitchToLinkedCompanyResponseToJSONTyped(json, false);
  }

  export function SwitchToLinkedCompanyResponseToJSONTyped(value?: SwitchToLinkedCompanyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'errorMessage': value['errorMessage'],
        'requiresTokenRefresh': value['requiresTokenRefresh'],
    };
}

